class SearchFocus {
    constructor() {
        this._init()
    }
    _init() {
        var els = document.querySelectorAll('[data-search-focus]')
        if(els.length == 0) {
            return;
        }
        this.el = els[els.length - 1]
        this.elAction = document.querySelector('[data-search-focus-action]')
        this.elAction.addEventListener('click', e => this.onClick(e))
        if(window.location.href.includes('search')) {
            this.elAction.classList.add('search-menu__button--focused')
        }
        this.elInput = this.el.querySelector('[data-input]')
        this.elInput.addEventListener('input', () => this.onInput())
        this.onInput()
    }
    onClick(e) {
        // if(window.location.href.includes('search')) {
        //     e.preventDefault()
        // }
        setTimeout(() => this.elInput.focus(), 1)
    }
    onInput() {
        if(this.elInput.value!="") {
            this.elAction.classList.add('search-menu__button--valid-input')
        } else {
            this.elAction.classList.remove('search-menu__button--valid-input')
        }
    }
}

export default SearchFocus